/** CMS extraJson 读写 — 对齐 AdminFront showOnHomepage / originalFile / boardCovers */

export function parseExtraJson(raw) {
  if (!raw) {
    return {}
  }
  if (typeof raw === 'object') {
    return raw || {}
  }
  try {
    return JSON.parse(raw) || {}
  } catch (e) {
    return {}
  }
}

export function getShowOnHomepage(entry) {
  const extra = parseExtraJson(entry && entry.extraJson)
  if (typeof extra.showOnHomepage === 'boolean') {
    return extra.showOnHomepage
  }
  return false
}

/**
 * 附件统一读取，对齐公开文件的对外展示名结构：
 * - attachments 数组（多附件）优先
 * - 兼容旧数据 originalFile（通知要闻单附件）与 fileUrl
 */
export function getAttachments(entry) {
  const extra = parseExtraJson(entry && entry.extraJson)
  if (Array.isArray(extra.attachments)) {
    return extra.attachments.filter(item => item && item.url)
  }
  if (extra.originalFile && extra.originalFile.url) {
    return [{
      id: 'original-file',
      name: extra.originalFile.name || '原文件',
      url: extra.originalFile.url,
      category: extra.originalFile.category || extra.fileCategory || 'document',
      originalName: extra.originalFile.originalName || ''
    }]
  }
  if (entry && entry.fileUrl) {
    return [{
      id: 'legacy-file',
      name: entry.fileUrl.split('/').pop() || '附件',
      url: entry.fileUrl,
      memberOnly: entry.memberOnly === '1'
    }]
  }
  return []
}

export function getOriginalFile(entry) {
  const extra = parseExtraJson(entry && entry.extraJson)
  if (Array.isArray(extra.attachments)) {
    const first = extra.attachments.find(item => item && item.url)
    if (first) {
      return first
    }
  }
  if (extra.originalFile && extra.originalFile.url) {
    return extra.originalFile
  }
  if (entry && entry.fileUrl) {
    return {
      name: entry.fileUrl.split('/').pop() || '原文件',
      url: entry.fileUrl,
      category: extra.fileCategory || 'document'
    }
  }
  return null
}

export function getBoardCovers(entry) {
  const extra = parseExtraJson(entry && entry.extraJson)
  const covers = extra.boardCovers || {}
  return {
    meeting_notice: covers.meeting_notice || '',
    important_news: covers.important_news || '',
    society_dynamics: covers.society_dynamics || '',
    work_progress: covers.work_progress || ''
  }
}

/**
 * 仅返回 showOnHomepage===true 的条目。
 * 首页展示由后台显式勾选控制，不再自动回退到全量列表。
 */
export function preferHomepageEntries(entries) {
  const list = Array.isArray(entries) ? entries : []
  return list.filter(item => getShowOnHomepage(item))
}

const HISTORY_TIME_RE = /^\d{4}-\d{2}-\d{2}$/

/** @returns {'asc'|'desc'} */
export function normalizeGalleryHistorySort(dir) {
  return String(dir || '').toLowerCase() === 'desc' ? 'desc' : 'asc'
}

/** @returns {string} 合法 YYYY-MM-DD，否则空串 */
export function getHistoryTime(entry) {
  const extra = parseExtraJson(entry && entry.extraJson)
  const raw = String((extra && extra.historyTime) || '').trim()
  if (!HISTORY_TIME_RE.test(raw)) {
    return ''
  }
  const parts = raw.split('-').map(Number)
  const m = parts[1]
  const d = parts[2]
  if (m < 1 || m > 12 || d < 1 || d > 31) {
    return ''
  }
  return raw
}

/** 历史相册照片的重要事件说明（可用于人员花名册、事件背景等描述）。 */
export function getGalleryImportantEvent(entry) {
  const extra = parseExtraJson(entry && entry.extraJson)
  return String((extra && extra.importantEvent) || '').trim()
}

/**
 * @param {*} a
 * @param {*} b
 * @param {'asc'|'desc'} [dir='asc']
 */
export function compareCmsByHistoryTime(a, b, dir = 'asc') {
  const order = normalizeGalleryHistorySort(dir)
  const ta = getHistoryTime(a)
  const tb = getHistoryTime(b)
  if (ta && tb) {
    const byTime = ta.localeCompare(tb)
    if (byTime !== 0) return order === 'desc' ? -byTime : byTime
  } else if (ta && !tb) {
    return -1
  } else if (!ta && tb) {
    return 1
  }
  const ida = Number((a && a.entryId) || 0)
  const idb = Number((b && b.entryId) || 0)
  return ida - idb
}

export function sortCmsByHistoryTime(entries, dir = 'asc') {
  const order = normalizeGalleryHistorySort(dir)
  return (Array.isArray(entries) ? entries.slice() : []).sort((a, b) => compareCmsByHistoryTime(a, b, order))
}
